import { memo, useCallback } from 'react';

import { appActions } from 'app/app.actions';
import { TopbarButton } from 'app/views/layout/components/layoutContainer/components/topBar/components/button/topbarButton';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent/commandKeybindingsTooltipContent';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

export const SmsTopbarButton = memo(function SmsTopbarButton(): JSX.Element {
  const dispatch = useAppDispatch();

  const openCompose = useCallback(() => {
    dispatch(
      appActions.showModal({
        modal: {
          type: 'app:composeSms',
        },
      }),
    );
  }, [dispatch]);

  const label = 'New SMS';

  const tooltip = (
    <CommandKeybindingsTooltipContent commandName="conversation:composeNewSms">
      {label}
    </CommandKeybindingsTooltipContent>
  );

  return (
    <TopbarButton
      icon="sms"
      label={label}
      tooltip={tooltip}
      onClick={openCompose}
    />
  );
});
